<template>
	<el-dialog title="提示" top="5vh" :visible.sync="dialogVisible" width="50vw" :close-on-click-modal="false"
		:before-close="close">
		<div class="dialog-head flex-sb" slot="title">
			<div>参赛作品评审</div>
			<div><i class="el-icon-close"></i></div>
		</div>
		<div class="dialog-content">
			<!-- <div class="tips flex">
				<div style="padding-right: 0.25rem;padding-top: 0.125rem">*</div>
				<div>
					请根据申报书项目团队信息、研究目标、工作基础、预期成果、单位支持措施内容进行打分
				</div>
			</div> -->
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm">
				<el-form-item label="评分(0-100分，保留两位小数)" prop="score">
					<el-input type="number" placeholder="请填写评分(0-100分,保留两位小数)" @blur="scoreBlur"
						v-model="ruleForm.score"></el-input>
				</el-form-item>
				<!-- <el-form-item label="是否立项" prop="is_approve">
					<el-select style="width: 100%;" v-model="ruleForm.is_approve" placeholder="请选择是否立项">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="评价意见" prop="comment">
					<cus-editor ref="editor" placeholder="评价意见"></cus-editor>
					
					<!-- 					<el-input resize="none" placeholder="请填写评价意见（500字以内）" :rows="10" type="textarea" maxlength="200"
						v-model="ruleForm.comment"></el-input> -->
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		applyReview,
		getReportDetail
	} from '@/common/api/report'
	// 富文本编辑器
	import cusEditor from '@/components/cus-editor/cus-editor.vue'
	export default {
		name: '',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			item_apply_id: {
				type: [String, Number],
				default: ''
			}
		},
		components: {
			cusEditor
		},
		watch: {
			value: {
				handler(v) {
					this.dialogVisible = v
				},
				deep: true,
				imediate: true,
			}

		},
		data() {
			return {
				dialogVisible: false,
				ruleForm: {
					score: '',
					comment: ''
				},
				rules: {
					score: [{
						required: true,
						message: '请填写最高100评分',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (value > 100) {
								callback(new Error('最高分不能超过100'))
							} else if (value <= 0) {
								callback(new Error('最低分不能小于1'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}],
					// comment: [{
					// 	required: true,
					// 	message: '请填写评价',
					// 	trigger: 'blur'
					// }, {
					// 	min: 1,
					// 	max: 500,
					// 	message: '请填写500字以内的评价',
					// 	trigger: 'blur'
					// }],
				},
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			async getDetail(id) {
				const {
					data
				} = await getReportDetail({
					item_apply_id: id
				})
				console.log(data)
				this.ruleForm = data
				this.$refs.editor.setHtml(data.comment)
			},
			submitForm(formName) {
				this.ruleForm.comment  = this.$refs.editor.getHtml()
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.ruleForm.item_apply_id = this.item_apply_id
						const {
							data
						} = await applyReview(this.ruleForm)
						this.$message.success('操作成功')
						this.$emit('refresh')
						this.close()
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			close() {
				this.ruleForm = {
					score: '',
					comment: ''
				}
				this.$refs.editor.setHtml('')
				this.$emit('close')
			},
			scoreBlur() {
				this.ruleForm.score = Number(this.ruleForm.score).toFixed(2)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.container {}

	.tips {
		color: red;
	}
	.ql-editor ::v-deep .ql-container .ql-editor {
		min-height: 300px;
	}
</style>
<style>
	
	.ql-snow .ql-picker.ql-size .ql-picker-label::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item::before {
		content: '14px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
		content: '12px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
		content: '18px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
		content: '32px';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item::before {
		content: '文本';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
		content: '标题1';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
		content: '标题2';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
		content: '标题3';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
		content: '标题4';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
		content: '标题5';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
		content: '标题6';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item::before {
		content: '标准字体';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
		content: '衬线字体';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
		content: '等宽字体';
	}
</style>